export default "__VITE_ASSET__DIzq189b__"